import { useState } from 'react';
import { rollFormula } from '@gm-binder/shared';
import { PageHeader, Card, Badge, Button, MarkdownView, EmptyState } from '../ui';
import { useBinder } from '../../lib/useBinder';
import shared from './sections.module.css';
import styles from './CursesSection.module.css';

/** Rollable curse table for adventures with a curses block. */
export function CursesSection() {
  const ctx = useBinder();
  const [rolledIndex, setRolledIndex] = useState<number | null>(null);
  if (!ctx) return null;
  const { adventure, instance, state, slug } = ctx;
  void instance;
  void state;
  void slug;

  const cursesBlock = adventure.curses;
  const curses = cursesBlock?.curses ?? [];

  if (!curses.length) {
    return (
      <div>
        <PageHeader eyebrow="Maledizioni" title={cursesBlock?.title ?? 'Maledizioni'} />
        <EmptyState
          icon="🕯️"
          title="Nessuna maledizione in questa avventura"
          description="Aggiungi una tabella delle maledizioni al contenuto dell'avventura per usarla qui."
        />
      </div>
    );
  }

  const rollCurse = () => {
    const result = rollFormula(`1d${curses.length}`);
    setRolledIndex(result.total - 1);
  };

  return (
    <div>
      <PageHeader
        eyebrow="Maledizioni"
        title={cursesBlock?.title ?? 'Maledizioni'}
        actions={
          <Button variant="primary" icon="🎲" onClick={rollCurse}>
            Tira sulla tabella
          </Button>
        }
      />

      <div className={shared.stack}>
        {cursesBlock?.intro && <MarkdownView>{cursesBlock.intro}</MarkdownView>}
        {cursesBlock?.description && <MarkdownView>{cursesBlock.description}</MarkdownView>}

        {curses.map((curse, index) => {
          const rolled = rolledIndex === index;
          return (
            <Card
              key={`${curse.roll ?? index}-${curse.name ?? 'maledizione'}`}
              className={[styles.row, rolled ? styles.rolled : undefined].filter(Boolean).join(' ')}
            >
              <Badge tone="ember">{curse.roll ?? index + 1}</Badge>
              <div>
                <div className={styles.nameRow}>
                  {curse.name && <strong className={styles.name}>{curse.name}</strong>}
                  {rolled && <Badge tone="success">Tirata</Badge>}
                </div>
                {curse.rule && <MarkdownView>{curse.rule}</MarkdownView>}
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
